import { TableViewStore, BaseListViewStore, DateRangeQueryPickerStore, QueryPickerStore } from "core/stores";
import { FacilityOrderService } from "application/facility-order/services";
import { ImportService } from 'application/import/services';
import { PersonService } from 'application/person/services';
import { BaasicDropdownStore } from 'core/stores'
import _ from 'lodash';
import { toDate } from 'core/utils';
import { FacilityService } from "application/facility/services";
import { ScheduleService } from "application/schedule/services";
import { action, observable } from 'mobx';

class FacilityOrderListViewStore extends BaseListViewStore {
	@observable accessor counter = 0;
	constructor(rootStore) {
        const facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        const importService = new ImportService(rootStore.application.baasic.apiClient);
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			autoInit: true,
			name: 'facility-order',
			routes: {
				details: item => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility-order.facility-order-template.list').pattern.replace(':id', item.id).replace(':facilityId', item.facilityId), '_blank');
				},
				edit: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id", id));
				},
				facilityPreview: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", id));
				},
				create: () => {
					this.rootStore.routerStore.goTo("master.app.main.facility-order.create");
				},
				orderingCalendar: async item => {
					const typeResponse = await scheduleService.getTypes();
					var calendarType = _.find(typeResponse.item, { abrv: 'ordering' });
					window.open(`${this.rootStore.routerStore.findRoute("master.app.main.schedule.calendar").pattern}?accountRepId=${item.accountManagerId}&calendarTypeId=${calendarType.id}&facilityId=${item.facilityId}`);
				},
				deliveryCalendar: async item => {
					const typeResponse = await scheduleService.getTypes();
					var calendarType = _.find(typeResponse.item, { abrv: 'delivery' });
					window.open(`${this.rootStore.routerStore.findRoute("master.app.main.schedule.calendar").pattern}?accountRepId=${item.accountManagerId}&calendarTypeId=${calendarType.id}&facilityId=${item.facilityId}`);
				}
			},
			actions: () => {
				return {
					find: async params => {
						if (this.counter === 0) {
							this.counter++;
							if (this.queryUtility.filter.accountManagerId === undefined) {
								let userRoles = this.rootStore.userStore.applicationUser.roles;
								this.isAccountManager = userRoles.includes("AccountManagers");
								const personService = new PersonService(this.rootStore.application.baasic.apiClient);
                                const response = await personService.getByUser(this.rootStore.userStore.applicationUser.id);

								if (this.isAccountManager && response) {
									this.queryUtility.filter.set('accountManagerId', response.data.id);
									params.accountManagerId = response.data.id;
								}
							}
						}

						const response = await facilityOrderService.find(_.extend({ isNiko:false, isNewFlow2: false, ...params }, {
							embed: 'CoreUser,Facility,AccountManager,ImportHeaderStatus,NextOrderingDate,NextDeliveryDate',
						}));

						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
									dateOfService: toDate(item.dateOfService),
									facility: item.facility && item.facility.name,
									accountManager: item.accountManager && item.accountManager.fullName,
									shippingStatus: item.shippingStatus,
									importHeaderStatus: item.importHeaderStatus && item.importHeaderStatus.name,
									importHeaderStatusAbrv: item.importHeaderStatus && item.importHeaderStatus.abrv,
									lastStatusChangeTime: item.lastStatusChangeTime && toDate(item.lastStatusChangeTime),
									nextOrderingDate: item.nextOrderingDate && toDate(item.nextOrderingDate),
									nextDeliveryDate: item.nextDeliveryDate && toDate(item.nextDeliveryDate),
									dateCreated: toDate(item.dateCreated),
								}
								);
							}))
						});
						return responseData;
					},
					delete: async item => {
						return await facilityOrderService.delete({ id: item.id });
					},
				};
			},
		});

        this.importStatusStore = new BaasicDropdownStore({}, {
			fetchFunc: async () => {
				const response = await importService.getStatus();
				return response.item;
			}
		});

        this.nextDeliveryDatePickerStore = new QueryPickerStore();
        this.nextOrderingDatePickerStore = new QueryPickerStore();
        this.dateOfServicePickerStore = new QueryPickerStore();
        this.createdAtPickerStore = new QueryPickerStore();

        this.personStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async (term) => {
				const response = await personService.find({ searchQuery: term, rpp: 200, isActive: true });
				return _.map(response.data.item, item => {
					return {
						id: item.id,
						name: item.firstName + ' ' + item.lastName
					};
				});
			}
		});

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		},
			{
				fetchFunc: async (term) => {
					const response = await facilityService.find({ isNiko: false, searchQuery: term, rpp: 100 });
					return _.map(response.data.item, item => {
						return {
							id: item.id,
							name: item.name
						};
					});
				}
			});

        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();

        this.queryUtility.onResetFilter = () => {
			this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = ""

			this.importStatusStore.setValue(null);

			this.personStore.setValue(null);
			this.personStore.filterTerm = ""

			this.nextDeliveryDatePickerStore.reset();
			this.nextOrderingDatePickerStore.reset();
			this.createdAtPickerStore.reset();
			this.dateOfServicePickerStore.reset();
			this.rangeQueryPickerStore.reset();
		}

        const userRoles = this.rootStore.userStore.user.roles;
        this.isAdmin = userRoles.includes("Administrators");
        this.isAccountManager = userRoles.includes("AccountManagers");

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'facility',
						title: "FACILITY_ORDER.LIST.COLUMNS.FACILITY",
						onClick: item => this.routes.details(item)
					},
					{
						key: 'accountManager',
						title: "FACILITY_ORDER.LIST.COLUMNS.ACCOUNT_MANAGER",
						onClick: item => this.routes.details(item)
					},
					{
						key: 'nextOrderingDate',
						title: "FACILITY_ORDER.LIST.COLUMNS.NEXT_ORDERING_DATE",
						onClick: item => this.routes.orderingCalendar(item),
						width: 150
					},
					{
						key: 'dateOfService',
						title: "FACILITY_ORDER.LIST.COLUMNS.DATE_OF_SERVICE",
						onClick: item => this.routes.orderingCalendar(item),
						width: 150
					},
					{
						key: 'nextDeliveryDate',
						title: "FACILITY_ORDER.LIST.COLUMNS.NEXT_DELIVERY_DATE",
						onClick: item => this.routes.deliveryCalendar(item),
						width: 150
					},
					{
						key: 'shippingStatus',
						title: "FACILITY_ORDER.LIST.COLUMNS.SHIPPING_STATUS",
						onClick: item => this.routes.details(item),
					},
					{
						key: 'importHeaderStatus',
						title: "FACILITY_ORDER.LIST.COLUMNS.IMPORT_STATUS",
						onClick: item => this.routes.details(item),
						width: 150
					},
					{
						key: 'dateCreated',
						title: "FACILITY_ORDER.LIST.COLUMNS.BT_RUN_DATE",
						onClick: item => this.routes.details(item),
						width: 150
					},
				],
				actions: {
					onEdit: item => this.routes.edit(item.facilityId),
					onPreview: (item) => this.routes.facilityPreview(item.facilityId),
					orderingCalendar: (item) => this.routes.orderingCalendar(item),
					onDelete: (this.isAdmin || this.isAccountManager) ? async (item) => this.onDelete(item) : null
				},
			})
		);
    }

	@action.bound
	async onDelete(item) {
		this.rootStore.modalStore.showConfirm(
			'FACILITY_ORDER.LIST.COLUMNS.DELETE_MESSAGE',
			async () => {
				try {
					await this.actions.delete(item);
					this.rootStore.notificationStore.success('FacilityOrder successfully deleted.');
					this.queryUtility.fetch();
				} catch (err) {
					this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'An error ocurred while trying to delete Facility Order.');                                                       
				}
			}
		);
	}

	@action.bound
	filterOnChange() {
		this.queryUtility.fetch();
	}
}

export default FacilityOrderListViewStore;